module.exports = __webpack_public_path__ + "static/img/commond2.3458963.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commond2.png
// module id = +iX9
// module chunks = 0